import { cloneDeep } from 'lodash';

import type { ClipGroup } from '../../../models/item';
import { FuelEntityType } from '../../../services';
import type { AssetForm } from '../../../store/forms';

export const toSaveClipGroupRequest = (form: AssetForm, ouId: string, clipGroupReq: ClipGroup | null = null) => {
  const clipGroup: ClipGroup = {
    id: form.mode === 'new' ? null : form.id,
    entityOuId: ouId,
    clipIds: form.clipIds,
    groupName: form.title,
    autoGroupingId: form.mode === 'new' ? null : clipGroupReq && clipGroupReq.autoGroupingId,
    entityType: FuelEntityType.ClipGroup,
    description: form.synopsis,
  };
  return clipGroup;
};

export const generateNewAssetForm = (oldFormData: AssetForm, newFormData: AssetForm) => {
  const newAssetForm = cloneDeep(newFormData);
  if (oldFormData.categories.length > 0) {
    newAssetForm.categories = oldFormData.categories;
  }
  if (oldFormData.common.categories.length > 0) {
    newAssetForm.common.categories = oldFormData.common.categories;
  }
  if (oldFormData.tags.length > 0) {
    newAssetForm.tags = oldFormData.tags;
  }
  if (oldFormData.synopsis) {
    newAssetForm.synopsis = oldFormData.synopsis;
  }
  if (oldFormData.embargoDate) {
    newAssetForm.embargoDate = oldFormData.embargoDate;
  }
  if (oldFormData.expireDate) {
    newAssetForm.expireDate = oldFormData.expireDate;
  }
  if (oldFormData.isLongFormContentEnabled) {
    newAssetForm.customFields = oldFormData.customFields;
  }
  newAssetForm.doNotDelete = oldFormData.doNotDelete;
  newAssetForm.common = oldFormData.common;
  newAssetForm.publicationDate = oldFormData.publicationDate;
  newAssetForm.displaySettings = oldFormData.displaySettings;
  newAssetForm.includeAsTransition = oldFormData.includeAsTransition;
  newAssetForm.accessSettings = oldFormData.accessSettings;
  newAssetForm.applyAutomatedTransitions = oldFormData.applyAutomatedTransitions;
  newAssetForm.linkedAssets = oldFormData.linkedAssets;
  return newAssetForm;
};
